import React from "react";
import Routes from "./Routes";
import { Toaster } from "components/ui/toaster";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  // Replace with your actual Google Client ID
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID_HERE";

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Routes />
      <Toaster />
    </GoogleOAuthProvider>
  );
}

export default App;
